import React from 'react';
import { NavLink } from 'react-router-dom';
import GO from '../assets/NFT 1.png';
// import '../styles/Navbar.scss';

const Navbar = () => {
  return (
    <header className="tech-header">
      <div className="header-container">
        {/* Brand / Logo */}
        <NavLink to="/" className="brand-logo" aria-label="Home">
          <div className="logo-wrapper">
            <img src={GO} className="logo-img" alt="Estelo logo" />
          </div>
          <div className="brand-text">
            <span className="brand-name">ESTELO.NET</span>
            <span className="brand-status">
              <span className="pulse-dot"></span> DEV_PORTFOLIO
            </span>
          </div>
        </NavLink>

        {/* Navigation Links */}
        <nav className="nav-menu">
          {/* <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `nav-link ${isActive ? 'active' : ''}`
            }
          >
            <span className="nav-index">01.</span> Home
          </NavLink> */}

          <NavLink
            to="/projects"
            className={({ isActive }) =>
              `nav-link ${isActive ? 'active' : ''}`
            }
          >
            <span className="nav-index">1.</span> Projects
          </NavLink>

          <NavLink
            to="/casestudy"
            className={({ isActive }) =>
              `nav-link ${isActive ? 'active' : ''}`
            }
          >
            <span className="nav-index">02.</span> Case Study
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;